import React from "react";

import {
  buildFoundryJSON,
  buildPdfHtml,
  buildTextExport,
  getExportFileBaseName,
} from "../characterCreatorUtils.js";

function downloadBlob(content, filename, mimeType) {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

function openPdfPreview(html) {
  const popup = window.open("", "_blank");
  if (!popup) return;
  popup.document.write(html);
  popup.document.close();
  popup.focus();
  setTimeout(() => popup.print(), 400);
}

export default function SummaryExport({ exportType, exportSnapshot, onExportTypeChange }) {
  const exportPreText =
    exportType === "json"
      ? JSON.stringify(buildFoundryJSON(exportSnapshot), null, 2)
      : exportType === "txt"
        ? buildTextExport(exportSnapshot)
        : "(Clique abaixo para gerar e abrir o PDF para impressão)";

  return (
    <div style={{ marginTop: "1.2rem" }}>
      <div className="export-tabs" id="exportTabs">
        <button
          type="button"
          className={`export-tab${exportType === "json" ? " active" : ""}`}
          data-export="json"
          onClick={() => onExportTypeChange("json")}
        >
          JSON — Foundry
        </button>
        <button
          type="button"
          className={`export-tab${exportType === "txt" ? " active" : ""}`}
          data-export="txt"
          onClick={() => onExportTypeChange("txt")}
        >
          Texto
        </button>
        <button
          type="button"
          className={`export-tab${exportType === "pdf" ? " active" : ""}`}
          data-export="pdf"
          onClick={() => onExportTypeChange("pdf")}
        >
          PDF
        </button>
      </div>
      <div className="export-content" id="exportContent">
        <pre id="exportPre">{exportPreText}</pre>
        <div className="export-actions" id="exportActions">
          {exportType === "json" ? (
            <>
              <button
                type="button"
                className="wiz-btn"
                onClick={() => navigator.clipboard.writeText(exportPreText)}
              >
                📋 Copiar
              </button>
              <button
                type="button"
                className="wiz-btn"
                onClick={() =>
                  downloadBlob(
                    exportPreText,
                    `${getExportFileBaseName(exportSnapshot)}.json`,
                    "application/json"
                  )
                }
              >
                ⬇ Download .json
              </button>
            </>
          ) : null}
          {exportType === "txt" ? (
            <>
              <button
                type="button"
                className="wiz-btn"
                onClick={() => navigator.clipboard.writeText(exportPreText)}
              >
                📋 Copiar
              </button>
              <button
                type="button"
                className="wiz-btn"
                onClick={() =>
                  downloadBlob(
                    exportPreText,
                    `${getExportFileBaseName(exportSnapshot)}.txt`,
                    "text/plain"
                  )
                }
              >
                ⬇ Download .txt
              </button>
            </>
          ) : null}
          {exportType === "pdf" ? (
            <button
              type="button"
              className="wiz-btn primary"
              onClick={() => openPdfPreview(buildPdfHtml(exportSnapshot))}
            >
              🖨️ Gerar e Abrir PDF
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
